<template>
  <v-card-title
    id="surveyPageTitle"
    class="px-md-12 pt-md-9 px-6 pt-4 d-flex align-start"
  >
    <div class="flex-fill pr-3">
      <div class="text-h3">{{ title }}</div>
      <p v-if="description" class="grey--text">{{ description }}</p>
    </div>
    <small class="grey--text" v-if="pageCount"
      >Page {{ pageIndex + 1 }} of {{ pageCount }}</small
    >
  </v-card-title>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    pageIndex: {
      type: Number,
      default: 0,
    },
    pageCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>
